import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';

export enum Option {
	ONLY_VISIBLE_TO_ME = 'OnlyVisibleToMe',
	DEFAULT_PERMISSIONS = 'DefaultPermissions',
	COPY_PERMISSIONS_FROM_ANOTHER_SPACE = 'CopyPermissionsFromAnotherSpace',
}

const OPTIONS_BY_EDITION = {
	[ConfluenceEdition.FREE]: [Option.DEFAULT_PERMISSIONS],
	[ConfluenceEdition.STANDARD]: [Option.DEFAULT_PERMISSIONS, Option.ONLY_VISIBLE_TO_ME],
	[ConfluenceEdition.PREMIUM]: [
		Option.DEFAULT_PERMISSIONS,
		Option.COPY_PERMISSIONS_FROM_ANOTHER_SPACE,
		Option.ONLY_VISIBLE_TO_ME,
	],
};

export function getOptionsByEdition(edition: ConfluenceEdition) {
	switch (edition) {
		case ConfluenceEdition.PREMIUM:
		case ConfluenceEdition.STANDARD:
			return OPTIONS_BY_EDITION[edition];
		case ConfluenceEdition.FREE:
		default:
			return OPTIONS_BY_EDITION[ConfluenceEdition.FREE];
	}
}
